import { render, staticRenderFns } from "./ModalVerifyCodeAuth2F.vue?vue&type=template&id=12dd23de&scoped=true&"
import script from "./ModalVerifyCodeAuth2F.vue?vue&type=script&lang=js&"
export * from "./ModalVerifyCodeAuth2F.vue?vue&type=script&lang=js&"
import style0 from "./ModalVerifyCodeAuth2F.vue?vue&type=style&index=0&id=12dd23de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dd23de",
  null
  
)

export default component.exports